import { statusLabel, statusTone } from "./status";
import Tag from "./Tag";

/** ร่าง / ยืนยัน DO / ออก INV แล้ว / รอนำส่ง 7-11 — a Tag, so it must sit inside TABLE_SX. */
export default function StatusChip({ status }: Readonly<{ status: string | null | undefined }>) {
  return <Tag tone={statusTone(status)}>{statusLabel(status)}</Tag>;
}
